module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/46b3bcec4c8ee66207e35ad0d92b343c.png";